/**
 * OrbDocCoreConceptsTraitsENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsTraitsENDocScreen
 */

import { useOrbDocCoreConceptsTraitsENDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsTraitsENDocScreenLogic';
import type { OrbDocCoreConceptsTraitsENDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsTraitsENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsTraitsENDocView as OrbDocCoreConceptsTraitsENDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsTraitsENDocBodyView } from '@/components/traits/OrbDocCoreConceptsTraitsENDocBodyView';
import { OrbDocCoreConceptsTraitsENDocFooterView } from '@/components/traits/OrbDocCoreConceptsTraitsENDocFooterView';
import { OrbDocCoreConceptsTraitsENDocHeaderView } from '@/components/traits/OrbDocCoreConceptsTraitsENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsTraitsENDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsTraitsENDocScreenConfig>;
}

export function OrbDocCoreConceptsTraitsENDocScreenView({ config: propsConfig }: OrbDocCoreConceptsTraitsENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsTraitsENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsTraitsENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsTraitsEN" trait="OrbDocCoreConceptsTraitsENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsTraitsENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsTraitsENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsTraitsENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsTraitsENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsTraitsENDocScreenView;
